var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'd-flex flex-column': _vm.$vuetify.breakpoint.smAndDown }},_vm._l((_vm.items),function(item){return _c('v-btn',{key:item.label,staticClass:"ma-2",attrs:{"to":item.routerLink,"text":""}},[_vm._v(_vm._s(item.label))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }